"use strict";
const button = document.querySelector('.publications-archive__toggle');
const publications = document.querySelectorAll('.publications-archive__category');
button === null || button === void 0 ? void 0 : button.addEventListener('click', () => {
    button.ariaPressed = button.ariaPressed === 'true' ? 'false' : 'true';
    for (const publication of publications) {
        publication.open = button.ariaPressed === 'true';
    }
});
